/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

const firebasePromises = require('../myFirebase/firebaseAuthPromises.js')
const firebaseFirestore = require('../myFirebase/firebaseFirestore.js')


// https://dev.to/decoeur_/managing-state-with-vuex---the-guide-i-wish-id-had-28h
Vue.use(Vuex)


console.log("STORE.JS  : " + "STORE.js: Initiating Store...");
export const store = new Vuex.Store({
    state: {
        currentUser: null, // the firebase user object   
        firestoreUser: null, //      
        isAdmin: false,    // Indicates if user is admin
        db: null,  // the firestore reference
        snackbarText: '',
        speechAPI: null, // Reveices highlevel events from SpeechAPI, type is MySpeechEvent
    },

    // Actions Async
    actions: {
       
        // Actions for Chat
        sendChatMessage(context, userObject) {
            let text = userObject.text;

            let user = context.state.currentUser;

            let email;
            let name;

            if (user) {
                email = context.state.currentUser.email;
                name = context.state.currentUser.displayName;
                if (name == null) name = email;
            }
            else {
                email = "anonymous";
                name = email;
            }

            

            return firebaseFirestore.writeChatMessage(1, email, name, text);
        }


    },

    getters: {
        speechAPI: state => () => state.speechAPI,


        user(state) {
            return state.currentUser;
        },

        firestoreUser(state) {
            return state.firestoreUser;
        },

     

        isFirebaseActive( state ) {
            return state.firebaseActive;
        },

        isStudent( state ) {
            
            // definitely not a student
            if (state.currentUser == null) return false;


            // anonymous user is not a student
            if (state.currentUser.isAnonymous) return false;

            if (state.currentUser.email.includes("haw-landshut.de")) {
                return true;
            }
            
            return false;
        },

        isAdmin(state) {
            return state.isAdmin;
        },

      


        isAuthenticated(state) {

            if (state.currentUser == null) {
                console.log("STORE.JS  : " + "STORE-GETTERS: isAutheticated (return false, no user logged in");
                return false;
            }

            if (state.currentUser.isAnonymous) {
                return false;
            }

            return true;
        },

        isUserActive(state) {
            if (state.currentUser == null) return false;
            return state.currentUser.emailVerified;
        }
    },

    mutations: {
        async setUser(state, val) {


            console.log("STORE.JS  : " + "Store mutation: setUser : " + val);
            state.isAdmin = false;  // Preset with false;

            state.currentUser = val;

            if (state.currentUser != null) {
                state.isAdmin = (state.currentUser.uid === process.env.VUE_APP_ADMIN_UID)
            }
            else {
                console.log("     Current User is Null. Not reading from Firestore.");
                state.firestoreUser = null;
                return;
            }

            // Reading from firestore
            if (!state.currentUser.emailVerified) {
                console.log("     Anonymous user - not reading from firestore");
            }
            else {

                console.log("     Reading user from Firestore : " + state.currentUser.uid);
                let userRecord = await firebaseFirestore.readUser(state.currentUser.uid);

                if (userRecord != null) {
                    console.log("     Success : " + userRecord.name);
                    state.firestoreUser = userRecord;
                } else {
                    console.log("     Failed");
                    state.firestoreUser = null;
                }
            }

        },

        /*
        async setConfig(state, val) {
            state.config = await firebaseFirestore.readUser(state.currentUser.uid);
        }
*/
        

        setGBIAccount(state, val) {
            // Read Userdata from Firebase
            
            if (state.firestoreUser == null) {
                console.log("     SEVERE: Did not find firestore user in the store.");
                return;
            }
            state.firestoreUser.gbiAccount = val;
        },
            
       

        setSnackbarText(state, val) {
            console.log("STORE.JS  : " + "Store mutation: setSnackbarText : " + val);
            state.snackbarText = val;
        },

        setVoiceEvent(state, val) {
            console.log("STORE.JS  : " + "Store mutation: setVoiceEvent : " + JSON.stringify(val));
            state.speechAPI = val;
        }
    }

})

// Export, damit wir den store im Router nutzen können
export default store; 